import React from 'react';

type Props = {};

export default function SignupPage({}: Props) {
  return <div>SignupPage</div>;
}
